import type { TemplateOwner, TemplateStatusFilter } from '../types/documentTemplates.types';
import { DOCUMENT_TYPE_OPTIONS } from './documentTypeLabels';

export const STATUS_FILTER_LABELS: Record<TemplateStatusFilter, string> = {
  published: 'Published',
  draft_only: 'Draft only',
};

export const OWNER_FILTER_LABELS: Record<TemplateOwner, string> = {
  platform: 'Platform',
  dealer: 'Dealer-owned',
};

const toOptions = <T extends string>(labels: Record<T, string>) =>
  (Object.entries(labels) as [T, string][]).map(([value, label]) => ({ value, label }));

export const TYPE_FILTER_OPTIONS = [{ value: '', label: 'All types' }, ...DOCUMENT_TYPE_OPTIONS];
export const STATUS_FILTER_OPTIONS = [{ value: '', label: 'All statuses' }, ...toOptions(STATUS_FILTER_LABELS)];
export const OWNER_FILTER_OPTIONS = [{ value: '', label: 'All owners' }, ...toOptions(OWNER_FILTER_LABELS)];
